import { setPushNotificationLogsTotalCountByGroupId } from '../../actions/notification/notificationAction';
import {
    SET_NOTIFICATIONS_DATA,
    SET_UNREAD_NOTIFICATION_COUNT,
    SET_PAGE_LIMIT
  } from '../../actions/types/types';
  
  const initState = {
    unreadNotificationCount: 0,
    notifications: [],
    page: 1,
    limit:10,
    totalCount:0,
    pushNotificationLogs:[],
    pushNotificationLogsTotalCount:0,
    pushNotificationLogsPage:1,
    pushNotificationLogsLimit:10,
    pushNotificationLogsByGroupId:[],
    pushNotificationLogsTotalCountByGroupId:0,
    pushNotificationLogsPageByGroupId:1,
    pushNotificationLogsLimitByGroupId:10
  };
  
  const NotificationReducer = (state = initState, action) => {
    switch (action.type) {
      case SET_NOTIFICATIONS_DATA:
        return {
          ...state,
          notifications: action.payload.data,
          totalCount: action.payload.totalCount
        };
      case SET_UNREAD_NOTIFICATION_COUNT:
        return {
          ...state,
          unreadNotificationCount: action.payload.data,
        };
      case SET_PAGE_LIMIT:
        return {
          ...state,
          page: action.payload.page,
          limit: action.payload.limit
        };
      case "SET_PUSH_NOTIFICATION_LOGS":
          return {
            ...state,
            pushNotificationLogs: action.payload.data,
          }; 
       case "SET_PUSH_NOTIFICATION_LOGS_TOTAL_COUNT": 
           return { ...state,
            pushNotificationLogsTotalCount: action.payload.data,
           }; 
       case "SET_PUSH_NOTIFICATION_LOGS_PAGE_LIMIT": 
           return { ...state,
            pushNotificationLogsPage: action.payload.page,
            pushNotificationLogsLimit: action.payload.limit
           }; 
       case "SET_PUSH_NOTIFICATION_LOGS_BY_GROUP_ID":
        return {
          ...state,
          pushNotificationLogsByGroupId: action.payload.data,
        }; 
       case "SET_PUSH_NOTIFICATION_LOGS_TOTAL_COUNT_BY_GROUP_ID": 
           return { ...state,
            pushNotificationLogsTotalCountByGroupId: action.payload.data,
           };      
       case "SET_PUSH_NOTIFICATION_LOGS_PAGE_LIMIT_BY_GROUP_ID": 
           return { ...state,
            pushNotificationLogsPageByGroupId: action.payload.page,
            pushNotificationLogsLimitByGroupId: action.payload.limit
           }; 
      default:
        return { ...state };
    }
  };
  
  export default NotificationReducer;
  